import { Declaration } from 'postcss'

const emptyRuleRemoverPlugin = () => ({
	postcssPlugin: 'emptyRuleRemover',
	Declaration: {
		'*': (d: Declaration) => {
			const { parent, value } = d
			const hasEmptyValue = !value.trim() || value === 'undefined'
			const isLoneChild = parent?.nodes.length === 1

			if (hasEmptyValue) {
				d.remove()

				if (isLoneChild) {
					parent?.remove()
				}
			}
		},
	},
})

emptyRuleRemoverPlugin.postcss = true as true

export default emptyRuleRemoverPlugin
